module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "section-white view-flex view-flex-middle"
  }, [_c('draggable', _vm._b({
    staticClass: "components-view",
    attrs: {
      "clone": _vm.cloneComponent
    },
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.initData),
      callback: function($$v) {
        _vm.initData = $$v
      },
      expression: "initData"
    }
  }, 'draggable', _vm.dragIssuesOptions, false), _vm._l((_vm.initData), function(item, index) {
    return _c('div', {
      key: item.name + '_' + index,
      staticClass: "component-control"
    }, [(item.name === 'goodsGrid') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-grid"
      }
    })]), _vm._v("\n            商品栅格\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'goodsScroll') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-scroll"
      }
    })]), _vm._v("\n            商品滚动\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'goodsCategoryList') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-scroll"
      }
    })]), _vm._v("\n            分类\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'marquees') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-marquees"
      }
    })]), _vm._v("\n            文字轮播\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'navigation') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-navigation"
      }
    })]), _vm._v("\n            图片导航\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'search') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-search"
      }
    })]), _vm._v("\n            搜索\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'slider') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-slider"
      }
    })]), _vm._v("\n            轮播\n          ")] : _vm._e(), _vm._v(" "), (item.name === 'store' && _vm.system_mode === 'platform') ? [_c('svg', {
      staticClass: "svg-icon",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": "#icon-store"
      }
    })]), _vm._v("\n            推荐店铺\n          ")] : _vm._e()], 2)
  }), 0), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleShowConfig
    }
  }, [_c('i', {
    staticClass: "iconfont icon-cog"
  }), _vm._v(" 小程序设置\n      ")])], 1), _vm._v(" "), _c('section', {
    staticClass: "section section-white view-warp"
  }, [_c('div', {
    staticClass: "template-view"
  }, [_c('div', {
    staticClass: "template"
  }, [_c('div', {
    staticClass: "template-header"
  }, [_c('div', {
    staticClass: "template-title",
    style: ('background: #fff url(' + _vm.headerBg + ') no-repeat bottom; background-size: 100% auto;')
  }, [_c('span', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "components-wrap",
    style: ('height: ' + (_vm.wheight - 240) + 'px;'),
    on: {
      "start": _vm.onStart,
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.components),
      callback: function($$v) {
        _vm.components = $$v
      },
      expression: "components"
    }
  }, 'draggable', _vm.dragViewOptions, false), _vm._l((_vm.components), function(item, index) {
    return _c('div', {
      key: item._uid || (item.name + '_' + index),
      staticClass: "component-item",
      on: {
        "click": function($event) {
          return _vm.setCurrent(index)
        }
      }
    }, [(_vm.editorIndex === index) ? _c('div', {
      staticClass: "iconfont icon-trash-alt",
      on: {
        "click": _vm.removeCurrent
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'coupon') ? _c('coupon', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'film') ? _c('film', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'goodsGrid') ? _c('goodsGrid', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'goodsScroll') ? _c('goodsScroll', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'goodsCategoryList') ? _c('goodsCategoryList', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'imgHotzone') ? _c('imgHotzone', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'marquees') ? _c('marquees', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'navigation') ? _c('navigation', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'search') ? _c('search', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'showcase') ? _c('showcase', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'slider') ? _c('slider', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e(), _vm._v(" "), (item.name === 'store' && _vm.system_mode === 'platform') ? _c('store', {
      attrs: {
        "res": item,
        "active": index == _vm.editorIndex
      }
    }) : _vm._e()], 1)
  }), 0), _vm._v(" "), (_vm.isOpenFaverite && _vm.faverite.length) ? _c('goodsGrid', {
    staticClass: "components-wrap-faverite",
    attrs: {
      "res": _vm.faverite
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "template-footer"
  }, [_c('div', {
    staticClass: "template-tabs",
    class: {
      'active': _vm.editorIndex === 'tabs'
    },
    style: ({
      background: _vm.tabs.config.backgroundColor,
      color: _vm.tabs.config.color
    }),
    on: {
      "click": function($event) {
        return _vm.setCurrent('tabs')
      }
    }
  }, [_c('div', {
    staticClass: "current-active"
  }), _vm._v(" "), _vm._l((_vm.tabs.data), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tab",
      style: (index === _vm.currentTab ? ("color:" + (_vm.tabs.config.selectedColor)) : '')
    }, [(!item.iconPath) ? _c('svg', {
      staticClass: "svg-icon",
      style: (index === _vm.currentTab ? ("color:" + (_vm.tabs.config.selectedColor)) : ''),
      attrs: {
        "aria-hidden": "true"
      }
    }, [_c('use', {
      attrs: {
        "xlink:href": ("#icon-" + (item.name))
      }
    })]) : [(index === _vm.currentTab) ? _c('img', {
      staticClass: "svg-icon",
      attrs: {
        "src": item.selectedIconPath || 'https://fakeimg.pl/60x60/EFEFEF/CCC/?text=icofont=lobster'
      }
    }) : _c('img', {
      staticClass: "svg-icon",
      attrs: {
        "src": item.iconPath || 'https://fakeimg.pl/60x60/EFEFEF/CCC/?text=icon&font=lobster'
      }
    })], _vm._v(" "), _c('div', {
      staticClass: "tab-text"
    }, [_vm._v(_vm._s(item.text))])], 2)
  })], 2)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "setting-view"
  }, [(_vm.editorIndex === null) ? _c('div', {
    staticClass: "view-placeholder"
  }, [_c('i', {
    staticClass: "iconfont icon-shapes"
  }), _vm._v("\n          请选择左侧挂件\n        ")]) : _vm._e(), _vm._v(" "), (_vm.editorData && _vm.editorData.name) ? [(_vm.editorData.name === 'navigation') ? _c('navigationEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs,
      "bindLinks": _vm.showLinks,
      "bindType": _vm.showType
    }
  }) : (_vm.editorData.name === 'coupon') ? _c('couponEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindCoupons": _vm.showCoupons,
      "bindImgs": _vm.showImgs
    }
  }) : (_vm.editorData.name === 'film') ? _c('filmEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "change": _vm.getVideo
    }
  }) : (_vm.editorData.name === 'goodsGrid') ? _c('goodsGridEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindGoods": _vm.showGoods
    }
  }) : (_vm.editorData.name === 'goodsCategoryList') ? _c('goodsCategoryListEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindGoods": _vm.showCategoryGoods
    }
  }) : (_vm.editorData.name === 'goodsScroll') ? _c('goodsScrollEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindGoods": _vm.showGoods
    }
  }) : (_vm.editorData.name === 'imgHotzone') ? _c('imgHotzoneEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs,
      "bindLinks": _vm.showLinks
    }
  }) : (_vm.editorData.name === 'marquees') ? _c('marqueesEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "change": _vm.updataArticle
    }
  }) : (_vm.editorData.name === 'search') ? _c('searchEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    }
  }) : (_vm.editorData.name === 'showcase') ? _c('showcaseEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs,
      "bindLinks": _vm.showLinks
    }
  }) : (_vm.editorData.name === 'slider') ? _c('sliderEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs,
      "bindLinks": _vm.showLinks
    }
  }) : (_vm.editorData.name === 'store') ? _c('storeEditor', {
    key: 'editor_' + _vm.editorIndex,
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindGoods": _vm.showGoods
    }
  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.editorData && _vm.editorData.name === 'tabs') ? _c('tabsEditor', {
    key: 'editor_tabs',
    attrs: {
      "res": _vm.editorData
    },
    on: {
      "bindImgs": _vm.showImgs,
      "bindLinked": _vm.showLinked
    }
  }) : _vm._e()], 2)]), _vm._v(" "), _c('section', {
    staticClass: "content-padded-s section-white content-center"
  }, [_c('el-button', {
    staticClass: "btn-save",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveConfig
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgsVisible,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeimgsVisible
    }
  }), _vm._v(" "), _c('linkSetter', {
    attrs: {
      "visible": _vm.linksVisible,
      "template_name": _vm.template_name
    },
    on: {
      "setLink": _vm.setLink,
      "closeDialog": _vm.closeDialog
    }
  }), _vm._v(" "), _c('linkCompare', {
    attrs: {
      "visible": _vm.linkStatue,
      "template_name": _vm.template_name
    },
    on: {
      "setLink": _vm.setLink,
      "closeDialog": _vm.closeDialog
    }
  }), _vm._v(" "), _c('goodsSelect', {
    attrs: {
      "items-visible": _vm.goodsVisible,
      "get-status": _vm.setItemStatus,
      "rel-store": _vm.relStore,
      "rel-items-ids": _vm.relItemsIds
    },
    on: {
      "chooseStore": _vm.pickGoods,
      "closeStoreDialog": _vm.closeDialog
    }
  }), _vm._v(" "), _c('goodsSelectCategory', {
    attrs: {
      "items-visible": _vm.goodsCategoryVisible,
      "get-status": _vm.setItemCategoryStatus,
      "rel-category": _vm.relCategoryId,
      "rel-items-ids": _vm.relItemsIds
    },
    on: {
      "chooseStore": _vm.pickGoods2,
      "closeStoreDialog2": _vm.closeDialog
    }
  }), _vm._v(" "), _c('couponPicker', {
    attrs: {
      "visible": _vm.couponsVisible
    },
    on: {
      "pickCoupon": _vm.pickCoupon,
      "closeDialog": _vm.closeDialog
    }
  }), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.show_sideBar,
      "title": '小程序设置',
      "width": "20"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_sideBar = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开启猜你喜欢"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": true,
      "inactive-value": false,
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.isOpenFaverite),
      callback: function($$v) {
        _vm.isOpenFaverite = $$v
      },
      expression: "isOpenFaverite"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开启小程序定位"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": true,
      "inactive-value": false,
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.isOpenLocation),
      callback: function($$v) {
        _vm.isOpenLocation = $$v
      },
      expression: "isOpenLocation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开启扫码功能"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": true,
      "inactive-value": false,
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.isOpenScancode),
      callback: function($$v) {
        _vm.isOpenScancode = $$v
      },
      expression: "isOpenScancode"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4d19165e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d19165e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/template/mall/distributor_default.vue
// module id = 2695
// module chunks = 0